import React from 'react';
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ErrorOutlineOutlined from '@material-ui/icons/ErrorOutlineOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';

const SimpleNotification = ({ openNotification, onClose, notificationText  }) => {
  const handleClose = () => {
    // Llama a la función onClose proporcionada por el padre
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      open={openNotification}
      onClose={handleClose}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '10px',
          padding: '10px',
          maxWidth: '500px',
          textAlign: 'center',
        }}
      >
        <div style={{ textAlign: "right" }}>
          <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose} style={{ marginLeft: 'auto' }}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </div>
        <div style={{ padding: '50px', paddingTop:"0", paddingBottom:"20px" }}>
          <ErrorOutlineOutlined style={{ fontSize: '60px', color: '#f44336' }} />
          <div style={{ marginBottom: '20px', fontSize: '24px', fontWeight: "400" }}>¡Información incorrecta o inválida!</div>
          <div style={{ fontSize: '14px' }}>
            {notificationText}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop:"20px", fontWeight:"bold" }}>
            <div style={{ display: 'flex', alignItems: 'center', marginRight:"10px" }}>
              <MailOutlineIcon style={{ marginRight: '5px' }} />
              soporte@firmadox.cl
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <PhoneOutlinedIcon style={{ marginRight: '5px' }} />
              +56 226 179 201
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SimpleNotification;
